
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/locations",
      function () {
        return require("private-next-pages/android/local/locations/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/locations"])
      });
    }
  